
import {
    ButtonHeading,
    CommonButton,
    CustomPagination,
} from "components";
import BootstrapTable from "components/BootstrapTable";

import React, { useContext, useEffect, useRef, useState } from "react";
import toast from "react-hot-toast";

import { Link, useNavigate } from "react-router-dom";
import LoadingBar from "react-top-loading-bar";
import StorageService from "utils/StorageServices/StorageServices";
import { UserContext } from "context";
import useDocumentTitle from "hooks/useDocumentTitle";
import { getUsablityList, paymentApprovalInvoiceListApi, walletInvoiceDownloadApi } from "_services/walletService/walletService";
import { utils } from "helper";
import { API, AppConfig } from "lib";
import moment from "moment";


const Invoices = () => {
    useDocumentTitle("Invoices | T360");
    const { masterData, mastersChild } = useContext(UserContext);
    const navigate = useNavigate();
    const loadingBarRef = useRef(null);
    const [loading, setLoading] = useState(false);
    let isToken = localStorage.getItem("token");

    const itemsPerPage = 25;
    const [totalItems, setTotalItems] = useState(0);
    const [usablityList, setUsablityList] = useState([])
    const [usabiltyDetails, setUsablityDetails] = useState("")
    const [downloadingId, setDownloadingId] = useState(null);
    const [offSet, setOffset] = useState(1);

    const columns = [
        // { header: "", accessor: "serial" },
        { header: "Date", accessor: "date" },
        { header: "Description", accessor: "description" },
        { header: "Amount", accessor: "amount" },
        { header: "Status", accessor: "status" },
        { header: "Invoice", accessor: "invoice_link" },

    ];

    const getStatusStyle = (status = "paid") => {
        const map = {
            paid: { label: "Active", color: "#22C55E" },
            cancelled: { label: "Cancelled", color: "#EF4444" },
            pending: { label: "Pending", color: "#F97316" },
        };
        const key = status?.toLowerCase();
        return map[key] || { label: status || "-", color: "#6B7280" };
    };
    useEffect(() => {
        getAddressBookList()
    }, [offSet]);


    const getAddressBookList = async () => {
        try {
            if (loadingBarRef.current) {
                loadingBarRef.current.continuousStart(); // Start the loading bar
            }
            let object = {
                limit: itemsPerPage,
                offset: offSet,
                company_id: StorageService.getCompanyId(),
            };

            const res = await paymentApprovalInvoiceListApi(object)
            if (res?.responseCode == 200) {
                console.log(res)
                setUsablityList(res?.data?.storeData)
                setUsablityDetails(res?.data?.company)
                setTotalItems(res?.data?.total_record)

            }

        } catch (error) {
            toast.error(error);
        } finally {
            if (loadingBarRef.current) {
                loadingBarRef.current.complete();
            }
        }
    };


    const handleDownloadInvoice = async (id) => {
        try {
            setDownloadingId(id);
            const payload = {
                company_id: StorageService.getCompanyId(),
                id: id,
                is_web: true,
            };

            const response = await fetch(`${AppConfig.api_baseurl}${API.WALLET_INVOICE_DOWNLOAD}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Token': `${isToken}`,
                },
                body: JSON.stringify(payload)
            });

            if (!response.ok) throw new Error('Network response was not ok');

            const contentDisposition = response.headers.get('Content-Disposition');
            const filenameMatch = contentDisposition?.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
            const filename = filenameMatch?.[1]
                ? decodeURIComponent(filenameMatch[1].replace(/['"]/g, ''))
                : `invoice-${id}.pdf`;

            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = filename;
            document.body.appendChild(a);
            a.click();
            a.remove();
            window.URL.revokeObjectURL(url);
            setDownloadingId(false);
        } catch (error) {
            setDownloadingId(false);
        }
    };


    const rowListData = (data) => {
        return data?.map((item, i) => {
            const { label, color } = getStatusStyle(item?.status);
            const typeMap = {
                1: "Subscription",
                2: "Wallet"
            };
            return {
                ...item,
                date: item?.createdAt
                    ? `${utils?.formatDateMonth(item?.createdAt)} ${utils?.formatTimeWithoutConvertnew(item?.createdAt)}`
                    : "-",
                amount: item?.plan_price ? `₹ ${item?.plan_price}` : "₹ 0",

                // ✅ Colored status text
                status: (
                    <span style={{ color, fontWeight: 500 }}>
                        {label}
                    </span>
                ),

                description: typeMap[item?.transaction_type] || "-",

                invoice_link: item?._id ? (
                    <span
                        onClick={() => handleDownloadInvoice(item._id)}
                        style={{
                            color: downloadingId === item._id ? "#9CA3AF" : "#2563EB",
                            textDecoration: "none",
                            cursor: downloadingId === item._id ? "not-allowed" : "pointer",
                            fontWeight: 500,
                        }}
                    >
                        {downloadingId === item._id ? "Downloading..." : "Download Invoice"}
                    </span>
                ) : "-",
            };
        });
    };

    const handlePageChange = (page) => {
        setOffset(page);
    };


    return (
        <div>
            <LoadingBar
                color="#ffa800"
                ref={loadingBarRef}
                height={4}
                shadow={true}
                loaderSpeed={1000}
            />

            <div className="__mainUtility_bxs">
                <div className='__payM_head'><h6>Invoices</h6></div>

                <BootstrapTable
                    tableClass="utilityTbl_bxs"
                    columns={columns}
                    data={rowListData(usablityList?.length ? usablityList : [])}
                    isLoading={loading}
                />

                <div className="paginationFt_avt ">
                    <CustomPagination
                        totalItems={totalItems}
                        itemsPerPage={itemsPerPage}
                        currentPage={offSet}
                        onPageChange={handlePageChange}
                    />
                </div>
            </div>
            <style>
                {`
        .__mainUtility_bxs {
        display: flex;
        flex-direction:column;
        height: calc(100vh - 109px);
        overflow: auto;
        }
        .__subsMain {
        padding: 11px 14px 0px;
        }
        .utilityTbl_bxs {
          overflow: auto;
          flex: 1;
        /*padding: 0px 14px 15px;*/
        }
        .utilityTbl_bxs ._tab_htLane {
          height: 100%;
          overflow: auto;
        }
          .utilityTbl_bxs ._tab_htLane .anv_fr_detailHead {
            height: 100%;
            overflow: auto;
          }
        .subscription-card {
  border: 1px solid #E8E7E7;
  height: 221px;
  margin: 0px;
  display: flex;
  flex-direction: column;
  border-radius: 6px;
  overflow: hidden;
}

.subscription-header {
  height: 40px;
  border-bottom: 1px solid #E8E7E7;
  background: #FAFAFA;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0px 12px;
}

.subscription-title {
  font-size: 14px;
  color: #001B50;
  font-weight: 400;
}

.wallet-section {
  display: flex;
  align-items: center;
  gap: 10px;
}

.wallet-balance {
  font-size: 14px;
  color: #001B50;
  font-weight: 500;
}

.subscription-details {
  display: flex;
  flex-direction: column;
  margin: 12px;
  gap: 5px;
}

.detail-row {
  display: flex;
  gap: 5px;
}

.detail-label {
  font-size: 14px;
  color: #001B50;
  font-weight: 500;
}

.detail-value {
  font-size: 14px;
  font-weight: 400;
  margin: 0;
}
`}
            </style>
        </div>

    );
};

export default Invoices;
